var x = (y) => {
	var x = {}; __webpack_require__.d(x, y); return x
} 
var y = (x) => (() => (x))
const __WEBPACK_NAMESPACE_OBJECT__ = x({ ["captureMessage"]: () => (__WEBPACK_EXTERNAL_MODULE__canopytax_error_logging_edba3bbe__.captureMessage), ["setupHandleError"]: () => (__WEBPACK_EXTERNAL_MODULE__canopytax_error_logging_edba3bbe__.setupHandleError) });